<template>
  <div class="module_course page_content observation_report master_observation_report" aria-label="Master Observation Report Page">
    <div class="row page_content_container">
      <div class="loader_container" v-if="!showPage">
        <stretch class="loader_v24"></stretch>
      </div>
      <div class="col-12 dasboard-left-section report-Page" v-if="showPage">

          <b-row>
            <b-col cols="12">
              <!-- Heading -->
              <b-row class="heading">
                <div class="col-8 hd_txt">
                  <span class="ace_sec_hd">Reports :: </span>
                  <span>
                    {{ reportName }}
                  </span>
                  <span class="hd_select_fld">
                    <label id="catalogTitle" aria-label="Type Select">
                      <b-form-select
                        v-model="currentGroup"
                        :options="groups"
                        class=""
                        value-field="name"
                        text-field="name"
                        disabled-field="notEnabled"
                        :title="currentGroup"
                      ></b-form-select>
                    </label>
                  </span>
                </div>
                <div class="col-4 hd_btn_container">
                  <input class="search_field" v-model="searchQuery" placeholder="search by name">
                  <b-btn class="btn ic_btn" @click="sort = 'sortD'" v-if="sort === 'sortA'">
                    <span class="ic22-sort"></span>
                  </b-btn>
                  <b-btn class="btn ic_btn" @click="sort = 'sortA'" v-if="sort === 'sortD'">
                    <span class="ic22-sort"></span>
                  </b-btn>
                  <b-btn @click="exportClassSummary">export</b-btn>
                </div>

              </b-row>

              <!-- Report -->
              <div class="row">
                <div class="col-12 competency-details-row data_table_container">
                  <table class="table" border="1">
                    <thead>
                      <tr>
                        <th v-for="(col, index) in columns">{{col.label}}</th>
                      </tr>
                    </thead>

                    <tbody>
                    <template v-for="item in itemsToShow" >
                      <tr v-if="showGroup(item)">

                        <td v-for="col in itemsMap[item.key]" :class="col.type">

                          <template v-if="col.id === 'name'">
                            <div class="status_container">
                              <div class="status">
                                <template v-if="item.status!=2">
                                  <b-btn
                                    class="btn_ic btn_mark"
                                    @click="openMarkCompleteModal(item)"
                                    :aria-label="$t('markCompletedAria')"
                                    :title="$t('markCompletedBtnTitle')"
                                    v-b-tooltip.hover>
                                      <span class="ic24 ic24-check"></span>
                                  </b-btn>
                                </template>
                                <template v-if="item.status===2">
                                  <span
                                    class="status_complete"
                                    :title="$t('completedTitle')">
                                      <span class="ic ic24-check"></span>
                                  </span>
                                </template>
                              </div>
                            </div>
                          </template>

                          <div class="ic_usr" v-if="col.id === 'name'" :style="{background: setThumbnailBgColor(col.colEntityId)}">
                            <span class="ic22-student1"></span>
                          </div>
                          <div class="ic_usr ic_supervisor" v-if="col.id === 'supervisor'" :style="{background: setThumbnailBgColor(col.instId)}">
                            <div class="bg_layer">
                              <span class="ic22-user-tie"></span>
                            </div>
                          </div>
                          <div :class="col.cssClass">
                            {{col.label}}
                          </div>
                          <div v-if="col.type === 'deadline'" class="row kc_container">
                            <div v-for="kc in kCStatusMap[col.userId+'_'+col.courseId+'_'+col.competencyId]" class="col kc_blc" :class="kc.cssClass" :title="kc.name + ': ' + kc.cssClass">
                              &nbsp;
                            </div>
                          </div>
                        </td>

                        <td class="deadline" v-if="(columns.length>itemsMap[item.key].length)">
                          <div class="deadline_4weekplus">
                            N/A
                          </div>
                        </td>

                        <td class="deadline" v-if="(columns.length>itemsMap[item.key].length)">
                          <div class="deadline_4weekplus">
                            N/A
                          </div>
                        </td>

                      </tr>
                    </template>
                    </tbody>

                  </table>
                </div>
              </div>
            </b-col>
          </b-row>

      </div>
    </div>
      <div class="custom_modal_v6">
        <b-modal class="" ref="markCompleteModal" size="lg" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop hide-footer no-close-on-esc centered>
            <div slot="modal-header" class="header-section">
              <div class="modal-title">Mark Course Complete For User</div>
              <div class="btn_container">
                <button type="button" class="btn_close" @click="closeMarkCompleteModal()" aria-label="close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 msg">
                Are you sure, you want to mark course: <b> {{markCompleteItem.courseName}} </b>complete for user <b>{{markCompleteItem.name}}</b> ?
              </div>
              <div class="col-12 btn_container">
                <b-btn @click.stop="markCompleted()" class="btn" aria-label="Yes">Yes</b-btn>
                <b-btn @click.stop="closeMarkCompleteModal()" class="btn" aria-label="No">No</b-btn>
              </div>
            </div>
        </b-modal>
      </div>

  </div>
</template>

<script>
import '../../../assets/module/sass/reports/classReport.scss'
/* eslint no-labels: ["error", { "allowLoop": true }] */
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import _ from 'lodash'
import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'masterObservationReport',
  props: ['uuid', 'courseIds', 'courseInfoMap', 'allCourses'],
  components: {
    CourseNav,
    CourseHeader,
    Stretch
  },

  data: () => {
    return {
      showPage: false,
      sort: 'sortA',
      selectedCourseIds: [],
      currentGroup: "In Progress",
        groups: [{name:"In Progress"},{name:"Completed"},{name:"All"}],
      columns: [
        {
          id: 'name',
          label: 'Student Name'
        },
        {
          id: 'section',
          label: 'Section'
        },
        {
          id: 'duration',
          label: 'Duration'
        },
        {
          id: 'startDate',
          label: 'Start Date'
        }

      ],
      userMap: {},
      itemsMap: {},
      itemsArray: [],
      markCompleteItem : {},
      observationsResponse: {},
      isAllSections: false,
      searchQuery: '',
      showObservation: false,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      competencyIds: {},
      kCStatusMap: {}
    }
  },

  watch: {
    sort (newSort) {
      this.itemsArray = this.sortArrayOfObjects(this.itemsArray, 'name', this.sort)
    }
  },

  mounted () {
    this.setupMasterObservationReport()
  },

  methods: {
    ...mapActions([
      'loadCourseDetailFromServer',
      'loadChildrenCompetencySummaryForClass',
      'loadObservationForClass',
      'markCourseCompetencyCompleted',
      'exportObservationoToCsv',
    ]),
    async setupMasterObservationReport () {

      if (this.uuid) {
        // load the current course
        await this.loadCourseDetailFromServer(this.uuid)
      } else {
        // TODO: All Sections Scenario
        this.isAllSections =  true

        // TODO: Might have to setup CourseIds by getting all courses this user has access to.
      }

      // if courseIds is empty, then push current course to the selectedCourseIds
      if (typeof this.courseIds !== 'undefined' && this.courseIds.length > 0) {
        this.selectedCourseIds.push(this.courseIds)
      } else {
        this.selectedCourseIds.push(this.uuid)
      }

      // Call ObservationForClass api
      this.observationsResponse = await this.loadObservationForClass({courseId: this.selectedCourseIds.join(', '), allCourses:this.allCourses})

      // Set up User map with the observation API response
      this.observationsResponse.forEach((item, i) => {
        if (!(item.userId in this.userMap)) {
          this.userMap[item.userId] = []
        }
        this.userMap[item.userId].push(item)

        if (this.columns.filter(e => e.id === item.titleForStudent).length === 0) {
          if (item.competencyType !== 'PLO') {
            this.columns.push({ id: item.titleForStudent, label:item.titleForStudent})
          }
        }
      })

      // Process items
      for (let [key, value] of Object.entries(this.userMap)) {
        // Value is competency obj
        value.forEach((item, i) => {
          if (item.competencyType === 'PLO') {
            let itemsMapKey = key + '_' + item.competencyId
            if (!(itemsMapKey in this.itemsMap)) {
              let nameObj = {
                id: 'name',
                label: item.firstName + ' ' + item.lastName,
                type: 'string',
                cssClass: 'usr_name',
                colEntityId: item.uuid
              }

              let supervisorNameObj = {
                id: 'supervisor',
                label: this.courseInfoMap[item.courseId]?this.courseInfoMap[item.courseId].instructorName:'',
                type: 'string',
                cssClass: 'usr_name',
                instId: this.courseInfoMap[item.courseId]?this.courseInfoMap[item.courseId].courseId:''
              }

              let sectionObj = {
                id: 'section',
                label: item.titleForStudent,
                type: 'string',
                cssClass: 'section'
              }

              let durationObj = {
                id: 'duration',
                label: this.courseInfoMap[item.courseId]?this.courseInfoMap[item.courseId].duration:'',
                type: 'string',
                cssClass: 'duration'
              }

              let startDateObj = {
                id: 'startDate',
                label: this.getFormattedDateTime(item.courseStartTime, true),
                type: 'date',
                cssClass: ''
              }

              this.itemsMap[itemsMapKey] = []
              this.itemsMap[itemsMapKey].push(nameObj)
              if (this.isSuperSupervisor) {
                this.itemsMap[itemsMapKey].push(supervisorNameObj)
              }
              this.itemsMap[itemsMapKey].push(sectionObj)
              this.itemsMap[itemsMapKey].push(durationObj)
              this.itemsMap[itemsMapKey].push(startDateObj)

              let itemsArrayObj = {
                name: item.firstName + ' ' + item.lastName,
                key: itemsMapKey,
                status:item.status,
                userId: item.userId,
                courseId:item.courseId,
                courseName : item.titleForStudent
              }
              this.itemsArray.push(itemsArrayObj)
            }
          } else if (item.competencyType === 'CLO') {

              let deadlineObj = {
                id: item.uuid,
                label: this.getFormattedDateTime(item.deadLineTime, true),
                type: 'deadline',
                cssClass: this.computeCSSClassBasedOnDeadline(item.deadLineTime, item.status),
                competencyId: item.competencyId,
                userId: item.userId,
                courseId: item.courseId
              }


              this.competencyIds[item.courseId+'_'+item.competencyId] = {
                competencyId: item.competencyId,
                courseId: item.courseId
              }

              let itemsMapKey = key + '_' + item.parentCompetencyId
              if (itemsMapKey in this.itemsMap) {
                this.itemsMap[itemsMapKey].push(deadlineObj)
              }
          }
        })
      }

      // Process KC status
      for (let [key, value] of Object.entries(this.competencyIds)) {
        let childrenComptencySummaryResponse = await this.loadChildrenCompetencySummaryForClass({courseId: value.courseId, competencyId: value.competencyId})
        childrenComptencySummaryResponse.forEach((item, i) => {
          if (item.competencyType !== 'CLO') {
            let key = item.userId + '_' + value.courseId + '_' + item.parentCompetencyId

            if (! (key in this.kCStatusMap)) {
              this.kCStatusMap[key] = []
            }
            let kcStatusObj = {
              name: 'KC' + item.order,
              userId: item.userId,
              parentCompetencyId: item.parentCompetencyId,
              status: item.status,
              cssClass: this.getCSSClassNameForCompletion(item.status)
            }
            this.kCStatusMap[key].push(kcStatusObj)
          }
        })

      }

      if (this.isSuperSupervisor) {
        this.columns.splice(1, 0, {
          id: 'supervisor',
          label: 'Supervisor Name'
        })
      }

      this.showPage = true

    },
    getCSSClassNameForCompletion (status) {
      if (status === 0) {
        return 'deadline_missed'
      }
      if (status === 1 || status > 1) {
        return 'deadline_completed'
      }
    },
    setThumbnailBgColor (uuid) {
      let numValue = uuid.replace(/[^0-9]/g, '')
      return '#' + numValue.slice((numValue.length - 9), (numValue.length - 3))
    },
    showGroup(item){
        if(this.currentGroup==='Completed'){
          return item.status==2
        }
        if(this.currentGroup==='In Progress'){
          return item.status!=2
        }
        if(this.currentGroup==='All'){
          return true
        }
    },
    closeMarkCompleteModal (){
        this.markCompleteItem = {}
        this.$refs['markCompleteModal'].hide()

    },
    openMarkCompleteModal (item){
      this.markCompleteItem = item
      this.$refs['markCompleteModal'].show()
    },
    markCompleted(){
        this.markCourseCompetencyCompleted({userId:this.markCompleteItem.userId, courseId:this.markCompleteItem.courseId}).then(resp => {
          this.itemsArray.forEach(item => {
              if(item.key===this.markCompleteItem.key){
                  item.status = 2
              }
          })
          this.$refs['markCompleteModal'].hide()
        })
    },
    getFormattedDateTime (timeInMillis, showOnlyDate) {
      if (timeInMillis === 0) {
        return 'N/A'
      }
      var d
      var str = ''
      d = new Date(timeInMillis)
      str += String(this.months[d.getMonth()])
      str += ' ' + d.getDate()
      str += ', ' + d.getFullYear()
      if (!showOnlyDate) {
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        var currSec = d.getSeconds()
        currSec = currSec + ''
        if (currSec.length === 1) {
          currSec = '0' + currSec
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ':' + currSec
        str += ' ' + amPm
      }
      return str
    },
    computeCSSClassBasedOnDeadline (deadline, status) {
      if (status === 2) {
        return 'deadline_completed'
      }
      if (this.isTwoWeekPlus(deadline)) {
        return 'deadline_4week'
      }
      if (this.isTwoWeekMinum(deadline)) {
        return 'deadline_2week'
      }
      if (this.isFourWeekPlus(deadline)) {
        return 'deadline_4weekplus'
      }
      if (this.isPassed(deadline)) {
        return 'deadline_missed'
      }
    },
    isTwoWeekMinum (deadLineTime) {
      var today = new Date()
      var currentPlus2Week = today.getTime() + 2*7*(60 * 24) * 60 * 1000
      // 0-2Weeks
      return (deadLineTime > today.getTime() && deadLineTime < currentPlus2Week )
    },
    isTwoWeekPlus (deadLineTime) {
      var today = new Date()
      var currentPlus2Week = today.getTime() + 2*7*(60 * 24) * 60 * 1000
      var currentPlus4Week = today.getTime() + 4*7*(60 * 24) * 60 * 1000
      // >2weeks
      return  (deadLineTime > currentPlus2Week && deadLineTime < currentPlus4Week)
    },
    isPassed (deadLineTime) {
      var today = new Date()
      return (deadLineTime >0 && deadLineTime < today.getTime())
    },
    isFourWeekPlus (deadLineTime) {
      var today = new Date()
      var currentPlus4Week = today.getTime() + 4*7*(60 * 24) * 60 * 1000
      return (deadLineTime > currentPlus4Week || deadLineTime === 0)
    },
    writeFile (data, fileName1) {
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents')
      let a = document.createElement('a')
      a.download = fileName1?'Observation_Report_'+fileName1+'.csv':'Observation_Report.csv'
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    async exportClassSummary () {
      let response = await this.exportObservationoToCsv({courseId: this.selectedCourseIds, competencyId: this.competencyId, allCourses:this.allCourses, status:this.currentGroup})
      let summaryCsvFile = response && response.fileContents ? response.fileContents : response
      let errors = response && response.error ? response.error : ''
      let warnings = response && response.warning ? response.warning : ''
      if (!summaryCsvFile || !summaryCsvFile.length || summaryCsvFile.length === 0) {
        return this.notifyFailure(errors)
      }
      this.writeFile(summaryCsvFile, this.currentGroup)
      if (warnings && warnings.length > 0) {
        this.notifyWarning(warnings)
      } else {
        this.notifySuccess('Observation Report Successfully Exported to Csv')
      }
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text,
        duration: 5000
      })
    },
    notifyWarning (text) {
      this.$notify({
        group: 'notify',
        type: 'warn',
        title: '',
        text: text
      })
    },
    sortArrayOfObjects (arr, propertyName, order) {

      if (order === 'sortA') {
        const sortedArr = arr.sort((a, b) => {
          if (a[propertyName] < b[propertyName]) {
            return -1
          }
          if (a[propertyName] > b[propertyName]) {
            return 1
          }
          return 0
        })
        return sortedArr
      }

      if (order === 'sortD') {
        const sortedArr = arr.sort((a, b) => {
          if (a[propertyName] > b[propertyName]) {
            return -1
          }
          if (a[propertyName] < b[propertyName]) {
            return 1
          }
          return 0
        })
        return sortedArr
      }

    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'fullClassSummary': state => state.course.fullClassSummary,
      'competencySummaryForClass': state => state.course.competencySummaryForClass,
      'childrenCompetencySummaryForClass': state => state.course.childrenCompetencySummaryForClass,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'userObj': state => state.user.userObj
    }),
    reportName () {
      if (this.isAllSections) {
        return 'All Sections'
      } else if (this.course) {
        return this.course.title
      }
    },
    isSuperSupervisor () {
      if (this.userObj && this.userObj.customPermission && this.userObj.customPermission.superSupervisorRole) {
        return true
      }
      return false
    },
    itemsToShow () {
      return this.itemsArray.filter(item => {
        return item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      })
    }
  }

}
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/app/course/components/MasterObservationReport.vue